import Tribe from "../../enum/Tribe";

export type TroopData = {
    [key: number]: TribeTroopData;
}

export type PartialTroopData = {
    [key: number]: PartialTribeTroopData
}

export type TribeTroopData = {
    1: Troop,
    2: Troop,
    3: Troop,
    4: Troop,
    5: Troop,
    6: Troop,
    7: Troop,
    8: Troop,
    9: Troop,
    10: Troop,
}

export type PartialTribeTroopData = {
    [key in keyof TribeTroopData]+?: Partial<Troop>
}

export type Troop = {
    id: number,
    attack: number,
    defenceInfantry: number,
    defenceCavalry: number,
    isInfantry: boolean,
    isScout: boolean,
    carry: number,
    speed: number,
    supply: number,
    trainingTime: number,
    trainingCost: number[],
    researchRequirements: Array<{
        gid: number,
        level: number,
    }>,
    tribeId: Tribe,
}

// One row can technically only have one hero, however, for report storage it might be useful to have multiple heroes in one row.
export type TroopRow = Record<keyof TribeTroopData, number> & { hero: number };

export function getEmptyTroopRow(): TroopRow {
    return {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        8: 0,
        9: 0,
        10: 0,
        hero: 0,
    }
}
